export class PermissionHelper {
  /**
   * Obtém a permissão específica de uma entidade convertendo da sessionStorage.
   * @param permissionString Exemplo: 'event.edit', 'quiz.view'
   * @returns boolean informando se possui ou não o acesso.
   */
  static getRole(permissionString: string): boolean {
    try {
      const pmsBase64 = sessionStorage.getItem('pms');
      if (!pmsBase64) {
        return false;
      }

      // Decodifica a string em base64 e converte de volta para JSON
      const pmsJson = atob(pmsBase64);
      const permissions = JSON.parse(pmsJson);

      // Divide a string (ex: 'event.edit' -> ['event', 'edit'])
      const parts = permissionString.split('.');
      if (parts.length === 2) {
        const entity = parts[0];
        const action = parts[1];
        
        // Verifica se a entidade existe e se a ação correspondente é true
        return !!(permissions[entity] && permissions[entity][action] === true);
      }

      return false;
    } catch (error) {
      console.error('Erro ao processar permissões (PermissionHelper):', error);
      return false;
    }
  }
}
